import { fetchFromApi, optionsForGetRequest } from 'api';

const getOrderId = esgridCompanyId => fetchFromApi(`/esgrid/report/order/${esgridCompanyId}`, optionsForGetRequest());

const getPdfData = orderId => fetchFromApi(`/esgrid/report/pdf/${orderId}`, optionsForGetRequest());

export default {
  getOrderId,
  getPdfData,
};
